<template>
  <div class="contact-form">
      <div class="errors" v-if="hasErrors">
        <h3 class="">Veuillez corriger les erreurs du formulaire</h3>
        <ul>
          <li v-for="(item, index) in errors" :key="index">
            {{ item }}
          </li>
        </ul>
      </div>
      <div class="success mb-3" v-if="success">
        <h3 class="">Votre message à bien été envoyé, merci.</h3>
      </div>
      <div class="row">
        <div class="col-12 col-md-6">
          <div class="input-group">
            <label for="">Prénom</label>
            <input v-model="firstName" type="text" class="input-form">
          </div>
        </div>
        <div class="col-12 col-md-6">
          <div class="input-group">
            <label for="">Nom</label>
            <input  v-model="lastName" type="text" class="input-form">
          </div>
        </div>
      </div>
      <div class="input-group">
        <label for="">Adresse e-mail</label>
        <input v-model="email" type="email" class="input-form">
      </div>
      <div class="input-group">
        <label for="">Sujet</label>
        <input v-model="subject" type="text" class="input-form">
      </div>
      <div class="input-group">
        <label for="">Message</label>
        <textarea v-model="message" name="" class="input-form" rows="10"></textarea>
      </div>
      <div class="input-group mt-5">
       <button @click="sendContactForm()" class="btn btn-primary btn-full">Envoyer le message</button>
      </div>
  </div>
</template>
<script>
import axios from 'axios'
import api from '@/api'
export default {
  data () {
    return {
      firstName: '',
      lastName: '',
      email: '',
      subject: '',
      message: '',
      hasErrors: false,
      errors: [],
      success: false
    }
  },
  methods: {
    /**
     * Validate contact form (client-side)
     */
    validateForm () {
      this.errors = []
      if (this.firstName === '') {
        this.errors.push('Le prénom est obligatoire')
      }
      if (this.firstName.length > 50) {
        this.errors.push('Le prénom est trop long')
      }
      if (this.lastName === '') {
        this.errors.push('Le nom est obligatoire')
      }
      if (this.lastName.length > 50) {
        this.errors.push('Le nom est trop long')
      }
      if (this.email === '') {
        this.errors.push('Adresse e-mail est obligatoire')
      }
      if (this.email.length > 50) {
        this.errors.push('Adresse e-mail est trop longue')
      }
      if (this.subject.length > 50) {
        this.errors.push('Le sujet est trop long')
      }
      if (this.subject === '') {
        this.errors.push('Le sujet est obligatoire')
      }
      if (this.message === '') {
        this.errors.push('Le message est obligatoire')
      }
      if (this.errors.length > 0) {
        this.hasErrors = true
      } else {
        this.hasErrors = false
      }
    },
    /**
     * Send contact form
     */
    sendContactForm () {
      this.validateForm()
      if (this.errors.length === 0) {
        // Call te request
        this.postContactForm()
        this.success = true
        this.hasErrors = false
      } else {
        this.success = false
        this.error = 'Problème de validation'
      }
    },
    /**
     * Post contact form
     * @request HTTP | POST
     */
    postContactForm () {
      const params = new URLSearchParams()
      params.append('firstName', this.firstName)
      params.append('lastName', this.lastName)
      params.append('subject', this.subject)
      params.append('email', this.email)
      params.append('message', this.message)
      axios({
        method: 'POST',
        url: api.send_contact_form,
        data: params
      }).then(response => {
        if (response.data.error) {
          this.success = false
          this.error = 'Tout les champs sont obligatoires'
        }
      }).catch(response => {
        this.error = response.data.error
      })
    }
  }
}
</script>

<style lang="sass" scoped>
  @import 'ContactForm'
</style>



// WEBPACK FOOTER //
// src/components/ContactForm/ContactForm.vue